import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { LayoutDashboard, Swords, Plus, Users, MessageSquare } from 'lucide-react';

interface MobileNavProps {
  className?: string;
}

const navigation = [
  { name: 'Home', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Challenges', href: '/wagers', icon: Swords },
  { name: 'Create', href: '/wagers/create', icon: Plus, highlight: true },
  { name: 'Friends', href: '/friends', icon: Users },
  { name: 'Messages', href: '/messages', icon: MessageSquare },
];

export function MobileNav({ className }: MobileNavProps) {
  const location = useLocation();

  return (
    <nav
      className={cn(
        'fixed bottom-0 left-0 right-0 z-50 border-t bg-background/80 backdrop-blur-xl',
        className
      )}
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex h-16 items-center justify-around px-2">
        {navigation.map((item) => {
          const isActive =
            location.pathname === item.href ||
            (item.href === '/friends' && location.pathname.startsWith('/friends')) ||
            (item.href === '/messages' && location.pathname.startsWith('/messages'));

          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                'flex flex-col items-center gap-1 px-3 py-2 text-xs font-medium transition-colors',
                item.highlight
                  ? 'text-primary'
                  : isActive
                    ? 'text-foreground'
                    : 'text-muted-foreground'
              )}
            >
              <div
                className={cn(
                  'flex h-10 w-10 items-center justify-center rounded-xl transition-colors',
                  item.highlight
                    ? 'bg-primary text-primary-foreground'
                    : isActive
                      ? 'bg-muted'
                      : ''
                )}
              >
                <item.icon className="h-5 w-5" />
              </div>
              <span>{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
